/**
 * Google Analytics 4 event helpers for ad-platform conversion tracking.
 *
 * The loader in index.html only attaches `window.gtag` when
 * VITE_GA_MEASUREMENT_ID is set at build time. Every helper here is a
 * no-op when gtag isn't present, so callers don't need to guard.
 *
 * Purchase events are NOT here. They fire server-side from the Stripe
 * checkout.session.completed webhook (see packages/api/src/lib/ga4.ts) so
 * they survive incognito, cleared storage, ad-blockers, and tab closes.
 */

function gtagAvailable(): boolean {
  return typeof window !== "undefined" && typeof window.gtag === "function";
}

export function trackSignUp(method = "oauth"): void {
  if (!gtagAvailable()) return;
  try {
    window.gtag!("event", "sign_up", { method });
  } catch {
    // Analytics must never break the app
  }
}
